import { List } from 'immutable';
import VIEWED_HOTELS_CHANGED from '../constants/viewedHotels';

export default function (state = List(), action) {
  switch (action.type) {
    case VIEWED_HOTELS_CHANGED: {
      const { payload } = action;
      const viewedHotels = Object.keys(payload).reduce(
        (list, key) => list.concat(Object.keys(payload[key]).map(Number)),
        [],
      );
      return List(viewedHotels);
    }
    default:
      return state;
  }
}
